import {Controller} from "stimulus"
import {validateFields, formSubmittable} from "/lib/assets/form-validation"

export default class extends Controller {
    static targets = ["frame", "select"]

    loadFields(event) {
        const medium = event.target.value
        this.frameTarget.setAttribute("src", `/interaction/touch_points/medium_fields?medium=${medium}`)
    }

    validate() {
        validateFields(this.element.closest('.touch-point-form'))
        formSubmittable(this.element.closest('.touch-point-form'))

    }
}